module.exports = __webpack_public_path__ + "static/media/color-grading.f55efd56.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/color-grading.mp4
// module id = 303
// module chunks = 0